import { render, staticRenderFns } from "./EditFabricantesPage.vue?vue&type=template&id=3aacb85e"
import script from "./EditFabricantesPage.vue?vue&type=script&lang=js"
export * from "./EditFabricantesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports